import fetchAllProducts from "@api/operations/fetch-all-products";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { NextSeo } from "next-seo";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import ProductCardGrid from "@components/ProductCardGrid";
import Spacer from "@components/Spacer";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;
  const { page } = query;
  const { products, pageInfo } = await fetchAllProducts(token, {
    pageRequest: {
      page: page ? parseInt(page as string) - 1 : 0,
      size: 6,
      direction: "ASC",
      sort: "id",
    },
  });

  return {
    props: {
      products,
      pageInfo,
    },
  };
};

export type IndexPropsType = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function Home({ products }: IndexPropsType) {
  return (
    <>
      <NextSeo title="Public Safety Cadets" />
      <Spacer size="md" />
      <Container>
        <ProductCardGrid products={products} />
      </Container>
    </>
  );
}

Home.Layout = MainLayout;
